module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 _.each(rounds, function(round) { _.each(round.matches, function(match) { 
__p+='\n	<a href="/match-centre/'+
((__t=( round.id ))==null?'':_.escape(__t))+
'/'+
((__t=( match.id ))==null?'':_.escape(__t))+
'"\n		class="match-centre-game-bar-match '+
((__t=( match.is_live ? 'live-match' : '' ))==null?'':_.escape(__t))+
' '+
((__t=( match.is_first ? 'js-round-id-'+match.round : '' ))==null?'':_.escape(__t))+
'">\n		';
 if (match.is_first) { 
__p+='\n			<div class="round-name">\n				<div>RD '+
((__t=( match.round ))==null?'':_.escape(__t))+
'\n				</div>\n			</div>\n			';
 } 
__p+='\n\n				<div class="match">\n					<div class="match-info">\n						<figure>\n							<img src="'+
((__t=( image_squads_path + match.home_squad_id ))==null?'':_.escape(__t))+
'.png" alt="'+
((__t=( match.home_squad_name ))==null?'':_.escape(__t))+
'">\n						</figure>\n\n						';
 if (match.is_scheduled) { 
__p+='\n							<div class="squad-ladder-place">\n								'+
((__t=( _.ordinalSuffixOf(_.get(match, 'home_ladder_place' , '' )) ))==null?'':_.escape(__t))+
'\n							</div>\n							';
 } else { 
__p+='\n								<div\n									class="squad-score '+
((__t=( match.home_score > match.away_score ? 'bold' : '' ))==null?'':_.escape(__t))+
' '+
((__t=( match.is_live ? 'live' : '' ))==null?'':_.escape(__t))+
'">\n									'+
((__t=( match.home_score ))==null?'':_.escape(__t))+
'\n								</div>\n								';
 } 
__p+='\n					</div>\n					<div class="match-results">\n						';
 if (match.is_scheduled) { 
__p+='\n							<p class="game-date-full">\n								'+
((__t=( match.date ))==null?'':_.escape(__t))+
'\n							</p>\n							<p class="game-date">\n								'+
((__t=( match.game_date ))==null?'':_.escape(__t))+
'\n							</p>\n							';
 } 
__p+='\n								';
 if (match.is_completed) { 
__p+='\n									<p class="complete">\n										FULL TIME\n									</p>\n									<span>Match Centre</span>\n									';
 } 
__p+='\n										';
 if (match.is_live) { 
__p+='\n											<p class="live">\n												LIVE\n											</p>\n											';
 if (match.time) { 
__p+='\n												<span>\n													'+
((__t=( match.time ))==null?'':_.escape(__t))+
'\n												</span>\n												';
 } 
__p+='\n													';
 } 
__p+='\n					</div>\n					<div class="match-info">\n						<figure>\n							<img src="'+
((__t=( image_squads_path + match.away_squad_id ))==null?'':_.escape(__t))+
'.png" alt="'+
((__t=( match.away_squad_name ))==null?'':_.escape(__t))+
'">\n						</figure>\n\n						';
 if (match.is_scheduled) { 
__p+='\n							<div class="squad-ladder-place">\n								'+
((__t=( _.ordinalSuffixOf(_.get(match, 'away_ladder_place' , '' )) ))==null?'':_.escape(__t))+
'\n							</div>\n							';
 } else { 
__p+='\n								<div\n									class="squad-score '+
((__t=( match.away_score > match.home_score ? 'bold' : '' ))==null?'':_.escape(__t))+
' '+
((__t=( match.is_live ? 'live' : '' ))==null?'':_.escape(__t))+
'">\n									'+
((__t=( match.away_score ))==null?'':_.escape(__t))+
'\n								</div>\n								';
 } 
__p+='\n					</div>\n				</div>\n	</a>\n	';
 }) }) 
__p+='';
}
return __p;
};
